import { providerService } from 'services/providers';

export const ModelosMulti = async () => {
  const { data } = await providerService.getModelosMulti();

  return data;
};
